import styled, { css } from 'styled-components';
import InlineSVG from 'svg-inline-react';

import type { TransitionStateType } from 'src/app/types';
import type { ThemeSpaceType } from 'src/styles/theme';

import type { DirectionType } from '.';

export const Overlay = styled.div<{ isShown: boolean }>`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: ${props => (props.isShown ? props.theme.opacities.overlay : props.theme.opacities.none)};
  background-color: ${props => props.theme.colors.capsuleBlue50};
  z-index: ${props => props.theme.zIndices.overlay};
  position: ${props => (props.isShown ? 'fixed' : '')};
`;

export const ModalContainer = styled.div<{ direction: DirectionType; transitionState: TransitionStateType }>`
  position: fixed;
  display: flex;

  padding: ${props => props.theme.space.s5};
  flex-direction: column;
  box-shadow: ${props => props.theme.shadows.dp2};
  overflow-x: auto;
  z-index: ${props => props.theme.zIndices.overlayMore};
  background-color: ${props => props.theme.colors.white};
  transition: ${props => props.theme.animationSpeeds.fast} ease-in;

  ${props =>
    props.theme.mediaQueries.medium &&
    (props.direction === 'left' || props.direction === 'right') &&
    css`
      padding: ${props => props.theme.space.s6} ${props => props.theme.space.s7};
    `}

  ${props =>
    props.direction === 'left' &&
    css`
      bottom: 0;
      top: 0;
      left: 0;
      width: 50rem;
      transform: ${({ transitionState }: { transitionState: TransitionStateType }) =>
        transitionState === 'entered' ? 'translateX(0%)' : 'translateX(-100%)'};
    `}
  ${props =>
    props.direction === 'right' &&
    css`
      bottom: 0;
      top: 0;
      right: 0;
      width: 50rem;
      transform: ${({ transitionState }: { transitionState: TransitionStateType }) =>
        transitionState === 'entered' ? 'translateX(0%)' : 'translateX(100%)'};
    `}

  ${props =>
    props.direction === 'up' &&
    css`
      bottom: 0;
      left: 0;
      width: 100vw;
      transform: ${({ transitionState }: { transitionState: TransitionStateType }) =>
        transitionState === 'entered' ? 'translateY(0%)' : 'translateY(100%)'};
      border-top-right-radius: ${props => props.theme.radii.large};
      border-top-left-radius: ${props => props.theme.radii.large};
    `}
  ${props =>
    props.direction === 'down' &&
    css`
      top: 0;
      left: 0;
      width: 100vw;
      transform: ${({ transitionState }: { transitionState: TransitionStateType }) =>
        transitionState === 'entered' ? 'translateY(0%)' : 'translateY(-100%)'};
      border-bottom-right-radius: ${props => props.theme.radii.large};
      border-bottom-left-radius: ${props => props.theme.radii.large};
    `}
`;

export const CloseButton = styled(InlineSVG)`
  display: inline-block;
  width: 2rem;
  height: 2rem;
  svg {
    width: 1.2rem;
    height: 1.2rem;
    margin: 0.4rem;
    fill: ${props => props.theme.colors.capsuleGray50};
  }
`;

export const CloseButtonContainer = styled.div<{ contentMargin?: ThemeSpaceType; direction: DirectionType }>`
  ${props =>
    (props.direction === 'left' || props.direction === 'right') &&
    props.theme.mediaQueries.medium &&
    css`
      margin-bottom: ${props.contentMargin ? props.theme.space[props.contentMargin] : '16.3rem'};
    `}
  display: flex;
  flex-direction: row-reverse;
`;
